import walletFinancialPositionsMessages from '../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../column';
import { RealEconomyProduct } from '../real-economy-macro-category';

export const realEconomyColumns: Column<RealEconomyProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderContract,
    key: 'newContractCode',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderObligation,
    key: 'obligation',
    type: 'amount',
  },
  /*{
    headerLabel: walletFinancialPositionsMessages.tableHeaderQuantity,
    key: 'quantity',
    type: 'amount',
  },*/
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderPaidValidated,
    key: 'paidValidated',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderPaidToBeValidated,
    key: 'paidToBeValidated',
    type: 'amount',
  },
  /*{
    headerLabel: walletFinancialPositionsMessages.tableHeaderCurrency,
    key: 'currency',
    type: 'string',
  },
  {
    headerLabel:
      walletFinancialPositionsMessages.tableHeaderAveragePurchasePrice,
    key: 'averagePurchasePrice',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderChange,
    key: 'change',
    type: 'number',
  },
  {
    headerLabel:
      walletFinancialPositionsMessages.tableHeaderShareDividedQuoteValue,
    key: 'counterShareValue',
    type: 'amount',
  },*/
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValueShort,
    key: 'counterValue',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderDate,
    key: 'date',
    type: 'date',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableCapitalEstimates,
    key: 'capitalEstimates',
    type: 'amount',
  },
  /*{
    headerLabel: walletFinancialPositionsMessages.tableHeaderItemsInTransit,
    key: 'itemsInTransit',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderBalancePosition,
    key: 'balancePosition',
    type: 'amount',
  },*/
];
